import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { ERClubBadge } from 'views/rebranded-module/location-module/LocationsViewV2/components';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .DLLocationItem': {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    fontSize: theme.spacing(2.25),
    '&.DLLocationLink': {
      fontSize: theme.spacing(2),
    },
    '&.DLLocationItemTitle': {
      marginBottom: theme.spacing(4),
    },
  },
  '& .DLocationLink': {
    display: 'inline-block',
  },
}));
export const StyledERClubBadge = styled(ERClubBadge)(({ theme }) => ({
  position: 'relative',
  top: theme.spacing(-0.25),
}));
export default StyledBox;
